
import { Logout } from '@/apis/comm/api'
import { defineComponent } from 'vue'

export default defineComponent({
  setup () {
    const logout = ()=>{
      Logout.request()
    }
    return {
    logout
    }
  }
})
